import React from 'react';
import moment from 'moment';
import Spinner from '../../../../../Spinner/Spinner';
import WarningModal from '../../../../../WarningModal';
import { useUnifiedFetch } from '../../../../../../hooks';

const styles = {
  row: { marginTop: '15px' },
  span: { marginBottom: '15px' },
  tableRow: { backgroundColor: '#8080802e', width: '50%' },
};

function PreferredProviderTest({ boxVpnAddress }) {
  const timer = React.useRef();

  const [isWarningModalOpen, setIsWarningModalOpen] = React.useState(false);
  const [seconds, setSeconds] = React.useState(0);

  const {
    isLoading: isTestInProgress,
    data: initiateTestResults,
    fetchData: initiateTest,
  } = useUnifiedFetch(`boxes/${boxVpnAddress}/initlteperfcheck`, false);
  const {
    isLoading: isFetchingTestResults,
    data: testResults,
    fetchData: fetchTestResults,
  } = useUnifiedFetch(`boxes/${boxVpnAddress}/fetchlteperf`, false);

  React.useEffect(() => {
    if (initiateTestResults?.response) {
      timer.current = setInterval(() => {
        setSeconds(prevSeconds => prevSeconds + 1);
      }, 1000);
    }
  }, [initiateTestResults]);

  React.useEffect(() => {
    if (seconds === 300) {
      fetchTestResults();
      clearInterval(timer.current);
      setSeconds(0);
    }
  }, [seconds]);

  const handleWarningConfirm = () => {
    initiateTest();
    setIsWarningModalOpen(false);
  };

  const handleWarningCancel = () => {
    setIsWarningModalOpen(false);
  };

  const renderInitiateTestResults = () => {
    if (initiateTestResults?.previousTest?.SimsInfo || testResults?.SimsInfo) {
      return;
    }

    if (initiateTestResults?.response) {
      return (
        <div className="mb-1 conectionDetails">
          <h1>{initiateTestResults.response}</h1>
        </div>
      );
    }
  };

  const renderElapsedTime = () => {
    if (seconds === 0) {
      return;
    }

    const minFloor = Math.floor(seconds / 60);
    const secondsRemainder = seconds % 60;

    const minString = minFloor < 10 ? `0${minFloor}` : minFloor;
    const secString = secondsRemainder < 10 ? `0${secondsRemainder}` : secondsRemainder;

    return (
      <span>
        Time: {minString}:{secString}
      </span>
    );
  };

  const simsInfo = testResults?.SimsInfo || initiateTestResults?.previousTest?.SimsInfo;
  const timestamp = testResults?.TimeStamp || initiateTestResults?.previousTest?.TimeStamp;
  const formattedTimestamp = moment(timestamp).format('MM-DD-YYYY, h:mm a');

  const isRunDisabled = seconds > 0;

  return (
    <>
      <div className="containerTest">
        <div className="row" style={styles.row}>
          <div className="col-12" style={styles.span}>
            <span className="under-line font-weight-bold">Preferred LTE / Cell Provider Test</span>
          </div>
          <div className="col-12">
            {renderInitiateTestResults()}
            {renderElapsedTime()}
          </div>
          <div className="col-12">
            {simsInfo && (
              <table className="table-condenced" style={{ 'border-collapse': 'collapse' }}>
                {simsInfo.map(item => {
                  return (
                    <>
                      <tr>
                        <td style={styles.tableRow}>SIM</td>
                        <td>{item.SIM}</td>
                      </tr>
                      <tr>
                        <td style={styles.tableRow}>PingAvg</td>
                        <td>{item.PingAvg}</td>
                      </tr>
                      <tr>
                        <td style={styles.tableRow}>PacketLoss</td>
                        <td>{item.PacketLoss}</td>
                      </tr>
                      <tr>
                        <td style={styles.tableRow}>Jitter</td>
                        <td>{item.Jitter}</td>
                      </tr>
                      <tr>
                        <td style={styles.tableRow}>Error</td>
                        <td>{item.Error}</td>
                      </tr>
                      <br />
                    </>
                  );
                })}
                <tr>
                  <td style={styles.tableRow}>Timestamp</td>
                  <td>{formattedTimestamp}</td>
                </tr>
                <br />
              </table>
            )}
          </div>
          <div className="col-12">
            <button
              onClick={() => setIsWarningModalOpen(true)}
              disabled={isRunDisabled}
              className="btn btn-primary btn-sm"
            >
              Run
            </button>
          </div>
        </div>
        {isTestInProgress && <Spinner customText="Initiating preferred provider test…" />}
        {isFetchingTestResults && (
          <Spinner customText="Fetching preferred provider test results…" />
        )}
      </div>
      {isWarningModalOpen && (
        <WarningModal
          isOpen={isWarningModalOpen}
          onConfirm={handleWarningConfirm}
          onCancel={handleWarningCancel}
          noButtonText="Close"
          yesButtonText="Continue"
        >
          Running the preferred provider test on LTE 4G only may result in a temporary loss of
          connectivity; proceed with caution.
        </WarningModal>
      )}
    </>
  );
}

export default PreferredProviderTest;
